//import Flickity from 'flickity';

export default {
  init() {
    // JavaScript to be fired on the home page

    /* eslint-disable */

	/* eslint-enable */

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
		
	/* eslint-disable */

    $(document).ready(function(){

        var heroswiper = new Swiper('.swiper-heroslider-container', {
          slidesPerView: 1,
          loop: true,
          fadeEffect: { crossFade: true },
          lazy: true,
          autoplay: true,
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 4,
          draggable: true,
          swipe: true,
          speed: 1000, 
          slidersPerView: 1,
          effect: "fade",
          autoplay: {
              delay: 5500,
              disableOnInteraction: true,
          },
        });


        // news carousel
        // var swiper = new Swiper('.swiper-news-container', {
        //   slidesPerView: 3,
        //   slidesPerGroup: 3,
        //   lazy: true,
        //   loop: false,
        //   spaceBetween: 30,

        //   breakpoints: {
        //     // when window width is >= 320px
        //     320: {
        //       slidesPerView: 1,
        //       spaceBetween: 15
        //     },
        //     // when window width is >= 480px
        //     480: {
        //       slidesPerView: 1,
        //       spaceBetween: 15
        //     },
        //     // when window width is >= 640px
        //     768: {
        //       slidesPerView: 2,
        //       spaceBetween: 30
        //     },
        //     998: {
        //       slidesPerView: 3,
        //       slidesPerGroup: 1,
        //       spaceBetween: 30
        //     },
        //     1200: {
        //       slidesPerView: 3,
        //       slidesPerGroup: 1,
        //       spaceBetween: 30
        //     }
        //   },

        //   // Navigation arrows
        //   navigation: {
        //     nextEl: '.swiper-news-button-next',
        //     prevEl: '.swiper-news-button-prev',
        //   },
          
        // });


    		// This will create a popup gallery from all photos in the gallery loop
        $('.popup-gallery').magnificPopup({
          delegate: "a",
          type: 'image',
          image: {
              titleSrc: function(item) {
                  return item.el.attr('title');
              }
          },
          gallery:{
            enabled:true
          }
        });

        // var typed = new Typed('.typed', {
        //   strings: ["health.^900", "well-being.^900", "emotional support.^900", "hormonal balance.^900", "gut health.^900", "skin care.^900", "energy.^900", "sleep.^900", "relaxation.^900", "life."],
        //   typeSpeed: 60,
        //   loop: true,
        //   loopCount: Infinity,
        //   backSpeed: 30
        // });


        // $('.slick-oils').slick({
        //   arrows: true,
        //   dots: true,
        //   autoplay: true,
        //   infinite: true,
        //   slidesToShow: 4,
        //   slidesToScroll: 4,
        //   draggable: true,
        //   swipe: true,
        //   responsive: [
        //     {
        //       breakpoint: 998,
        //       settings: {
        //         arrows: true,
        //         slidesToShow: 3,
        //       }
        //     },
        //     {
        //       breakpoint: 768,
        //       settings: {
        //         arrows: true,
        //         slidesToShow: 2,
        //       }
        //     },
        //     {
        //       breakpoint: 480,
        //       settings: {
        //         arrows: true,
        //         slidesToShow: 1,
        //       }
        //     }
        //   ]
        // });

        // $(document).ready(function(){
        //     $('#more .form-row .mb-4').matchHeight();
        // });
        // $(window).resize(function() {
        //     $('#more .form-row .card .card-body').matchHeight();
        // });
  

    });



    /* eslint-enable */
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/home.js